import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {UrlQueryService} from '../../../common/url-query/url-query.service';
import {AttributesApiService} from '../attributes/attributes-api.service';
import {addDictionaryAttributesAsProperties, restructureFilterParams} from '../userUtility';

@Injectable({
  providedIn: 'root'
})
export class GroupsApiService {
  constructor(private http: HttpClient,
              private attributesApiService: AttributesApiService) {
  }

  readonly groupsUrl: string = 'identity/userGroup';

  getGroups(): Promise<any> {
    return this.http.get(this.groupsUrl).toPromise();
  }

  getGroup(id): Promise<any> {
    return this.http.get(this.groupsUrl + '/' + id).toPromise();
  }

  getGroupsNames(ids): Promise<any> {
    const groupNames: any = [];

    return this.getGroups()
      .then((groups) => {
        groups.forEach((group) => {
          const index = ids.indexOf(group.id);

          if (index >= 0) {
            groupNames[index] = group.name;
          }
        });

        return groupNames;
      });
  }

  getGroupDryRun(group: any, parameters): Promise<any> {
    restructureFilterParams(parameters);
    const url = UrlQueryService.addQueryParameters(this.groupsUrl + '/dryRun', parameters);

    return this.http.post(url, group).pipe(
      map((value: any) => {
        value.users.forEach((user) => {
          addDictionaryAttributesAsProperties(user);
        });

        return value;
      })
    ).toPromise();
  }

  addGroup(group): Promise<any> {
    return this.http.post(this.groupsUrl, group).toPromise();
  }

  editGroup(group): Promise<any> {
    const url = this.groupsUrl + '/' + group.id;
    return this.http.put(url, group).toPromise();
  }

  deleteGroup(id): Promise<any> {
    const url = this.groupsUrl + '/' + id;
    return this.http.delete(url).toPromise();
  }


  prepareDataForGroupEdit(groupId: number): Promise<any> {
    return Promise.all([this.attributesApiService.getAttributes(), this.getGroup(groupId)]);
  }

  private groupFilter(groups, query): any {
    return this.filterQueryString(groups, query);
  }

  private filterQueryString(groups, query): any {
    return groups.filter((group) => {
      return this.stringContains(group.name, query) || this.stringContains(group.description, query);
    });
  }

  private stringContains(str, text): any {
    return str && str.toLowerCase().includes(text.toLowerCase());
  }
}
